module.exports = __webpack_public_path__ + "img/imag9.b3a5100d.png";